export class StorageConstants {
  public readonly SSO_CONFIRM_RESP = 'SSO_CONFIRM_RESP';
  public readonly INPROGRESS_ADD_ACCOUNT_FORM = 'INPROGRESS_ADD_ACCOUNT_FORM';
  public readonly MDM_PROFILE = 'MDM_PROFILE';
}

export const STORAGE_CONST = {
  
  SESSION_KEY: 'sessionKey',
  MSAL_LOGIN: 'msal-login',
  SERVICE_ACCOUNT_ID: (service: string) => `${service}-account-id`,
  FIRST_RUN_PERMISSION: 'firstRunPermission',
  DOMAIN_INFO: 'domaininfo',
  BOX_TOKEN: 'boxtoken',
  DROP_BOX: 'dropbox',
  ONE_DRIVE: 'onedrive',
  SERVICE: 'service',
  BOX: 'box',
  OFFICE_365: 'office365',
  email: 'email',
  EMAIL_ACCOUNT: (service: string, id: string) => `email-${service}-${id}`,
  CUSTOMER_INFO: "customerInfo"
};
